export default __webpack_public_path__ + "static/media/2412255.039cd1e9.webp";